import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-width: 100%;
  overflow: hidden;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
`;

export const TeamContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
`;

export const TeamWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const TeamLogo = styled.div`
  width: 60px;
  height: 60px;
`;
export const TeamName = styled.div`
  font-size: 14px;
  color: #000;
  line-height: 23px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;

export const TeamRank = styled.div`
  font-size: 10px;
  color: #999;
  line-height: 15px;
`;

export const Versus = styled.div`
  margin: 0 35px;
  width: 50px;
  height: 50px;

  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    width: 50px;
    height: 50px;
    background-color: #f1f2f4;
    transform-origin: center;
  }

  & > span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #bbb;
    font-size: 20px;
    font-family: verdana, sans-serif;
  }
`;

export const ChartContainer = styled.div`
  padding: 0 15px;
  margin-top: 20px;
  width: calc(100% - 30px);
`;
export const ChartRow = styled.div`
  &:not(:first-child) {
    margin-top: 20px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const ChartTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ChartValue = styled.span`
  font-size: 15px;
  color: #222;
  line-height: 23px;
  &:first-child {
    margin-right: auto;
  }
  &:last-child {
    margin-left: auto;
  }
`;

export const ChartName = styled.em`
  font-size: 10px;
  color: #666;
  line-height: 23px;
`;

export const ChartLineWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Chart = styled.div`
  flex: 1;
  height: 5px;
  background: #f1f2f4;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &:first-child {
    justify-content: flex-end;
    margin-right: 1px;
  }
`;

export const ChartFill = styled.em`
  height: 100%;
  background: #54575e;
  ${(props) =>
    props.isWinner &&
    css`
      background: #ed2026;
    `}
`;
